import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';
import { BP_LAPTOP, BP_TABLET } from '@rsos/constants/breakpoints';

export const ResultsContainer = styled(Box).attrs(() => ({
  display: 'block',
  position: 'absolute',
  padding: 0,
  bg: 'background',
}))`
  margin: -10px 0 0;
  overflow: hidden;
  list-style: none;
  border: ${({ theme }) => `1px solid ${theme.colors.lightLineDivider}`};
  box-shadow: ${({ theme }) =>
    `0px 5px 13px 0px ${theme.colors.lightLineDivider}`};
  top: 50px;
  left: -1px;
  z-index: 20;
  width: 264px;
  border-radius: 5px;
  max-width: ${({ maxWidth }) => maxWidth}px;
  @media (max-width: ${BP_LAPTOP}px) {
    width: 748px;
    left: -1px;
  }
  @media (max-width: ${BP_TABLET}px) {
    width: 580px;
    left: -1px;
  }
`;

export const ResultWrapper = styled(Box).attrs({
  padding: '10px',
  horizontal: true,
  cursor: 'pointer',
})`
  &:hover {
    background-color: ${({ theme }) => theme.colors.foreground};
  }
  div:last-child {
    border-bottom: none;
  }
`;

export const OptionCategory = styled(Text).attrs({
  color: 'secondaryText',
  size: 'normal',
  padding: '10px',
  fontWeight: 'bold',
})``;

export const SearchOption = styled(Text).attrs({
  color: 'secondaryText',
  size: 'small',
  marginRight: 'auto',
})``;

export const SearchAbbrev = styled(Text).attrs({
  color: 'secondaryText',
  size: 'small',
})`
  justify-content: flex-end;
`;
